<template>
  <transition appear name="slide">
    <div class="download-wrapper">
      <div class="top-bar">
        <i class="el-icon-arrow-left" @click="$router.back()"></i>
      </div>
      <div class="app-info">
        <img class="logo" :src="appInfo.previewLogo" alt />
        <p class="app-name">{{ appInfo.appName }}</p>
      </div>

      <div class="footer">
        <img class="rocket" src="~assets/images/rocket.png" />
        <div class="btns-wrapper">
          <!-- <span class="btn" @click="handleClickDownload('ios')">iPhone下载</span> -->
          <span class="btn" @click="handleClickDownload('android')">Android下载</span>
        </div>
        <div class="footer-text">蜀ICP备2023037657号</div>
      </div>
    </div>
  </transition>
</template>

<script>
import loginApi from 'api/login.js';

export default {
  name: 'DownloadPage',
  data() {
    return {
      appInfo: {},
      androidUrl: '',
      iosUrl: ''
    };
  },
  created() {
    if (this.$route.params) {
      this.appInfo = this.$route.params;
    }
    this.getAndroidAddressData(this.appInfo.appCode);
    this.getIOSAddressData(this.appInfo.appCode);
    // console.log();
  },
  methods: {
    // 获取安卓ios下载地址
    getAndroidAddressData(appCode) {
      loginApi.getAndroidAddress({ appCode }).then(res => {
        if (res.data.code === 200) {
          this.androidUrl = res.data.data.downloadAddress;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    getIOSAddressData(appCode) {
      loginApi.getIOSAddress({ appCode }).then(res => {
        if (res.data.code === 200) {
          this.iosUrl = res.data.data.downloadAddress;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 点击下载
    handleClickDownload(type) {
      if (type === 'android') {
        window.open(this.androidUrl);
      } else if (type === 'ios') {
        window.open(this.iosUrl);
      }
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.download-wrapper {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;

  .top-bar {
    height: 44px;
    line-height: 44px;
    padding-left: 10px;
    color: #333333;
  }

  .app-info {
    margin-top: 20px;
    text-align: center;

    .logo {
      width: 96px;
      height: 96px;
    }

    .app-name {
      width: calc(~'100% - 20px');
      margin: 4px 0;
      padding: 0 10px;
      font-size: 22px;
      font-weight: 500;
      color: #333333;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: -1;

    .rocket {
      width: 100%;
    }

    .btns-wrapper {
      box-sizing: border-box;
      position: absolute;
      bottom: 66px;
      left: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 44px;
      padding: 0 10%;

      .btn {
        display: inline-block;
        width: 45%;
        min-width: 110px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border: 2px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        font-size: 14px;
      }

      .btn:active {
        background-color: #409dff;
      }
    }

    .footer-text {
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 100%;
      height: 14px;
      line-height: 14px;
      font-size: 10px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }
  }
}
</style>
